// import React from "react";
// import { Modal } from "react-bootstrap";
// import { useDispatch, useSelector } from "react-redux";
// import { bindActionCreators } from "redux";
// import { Actions } from "../../../Action";
// import "./AFModalsStyles.css";
// import MultiSelectCmTwo from "../../MultiSelectCmTwo/MultiSelectCmTwo";
// import { filterDomainsForComponent2 } from "../../../utils";
// import { BASE_URL, currentGroup } from "../../../API/url";

// export function DataExportModal() {
//   const [domains, setDomain] = React.useState([]);
//   const [startDate, setStart] = React.useState("");
//   const [endDate, setEnd] = React.useState("");
//   const dispatch = useDispatch();
//   const { advanceFilterModalToggle } = bindActionCreators(Actions, dispatch);
//   const modalState = useSelector((state) => state.domain);
//   // const searchState = useSelector((state) => state.search);
//   const userState = useSelector((state) => state.user);
//   const cmRootState = useSelector((state) => state.cmRoot);

//   const maxDate = () => {
//     let newDate = new Date();
//     return newDate.toISOString().split("T")[0];
//   };

//   const onChangeStartDate = (date) => {
//     let newDate = new Date(date);
//     setStart(newDate.toISOString().split("T")[0]);
//   };
//   const onChangeEndDate = (date) => {
//     let newDate = new Date(date);
//     setEnd(newDate.toISOString().split("T")[0]);
//   };
//   const onClickSubmit = () => {
//     const mapDomains = domains.map(dom=>{
//       return dom.indexId;
//     });
//     let levelId = cmRootState.selecetdRoutingValue;
//     let levelValue = levelId === 3 ? "" : cmRootState.selectedGeoLevel["label"];
//     let commonUrl = BASE_URL+'/cmuser/group/'+currentGroup+'/dataexport?type='+'expertrecords'+'&status=answered&showanswer=true';
//     let startTimeParam = startDate != "" ? `&starttime=${startDate}` : "";
//     let endTimeParam = endDate != "" ? `&endtime=${endDate} 23:59:59` : "";
//     let domainParam = domains != "" ? `&domains=${encodeURIComponent(mapDomains.sort().toString())}` : "";
//     let fullLink = `${commonUrl}&levelid=${levelId}&levelvalue=${levelValue}${startTimeParam}${endTimeParam}&timezone=${Intl.DateTimeFormat().resolvedOptions().timeZone}${domainParam}`;
//     window.open(fullLink, '_blank');
//     advanceFilterModalToggle({ bool: false, value: "" })
//   };
//   return (
//     <>
//       <div>
//         <Modal
//           show={modalState.modalState}

//           style={{marginTop:"5%"}}
//           onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
//           backdrop="static"
//         >
//           <Modal.Header
//             closeButton
//             closeVariant="white"
//             className="modalHeaders"
//           >
//             <Modal.Title style={{ fontSize: "17px" }}>
//               <i className="fa fa-files-o"></i> &nbsp;&nbsp;Data Export
//             </Modal.Title>
//           </Modal.Header>
//           <Modal.Body style={{ paddingBottom: "0px" }}>
//             <div style={{ marginTop: "5px", width: "90%", margin: "auto", marginInline:'0px' }}>
//               <div
//                 style={{
//                   display: "flex",
//                   // color: "grey",
//                   fontSize: "16px",
//                   alignItems: "center",
//                   justifyContent:'center',
//                   fontWeight:'300'
//                 }}
//               >
//                 <div
//                   style={{ width: "20%", textAlign: "left", fontSize: "15px" }}
//                 >
//                   Date:
//                 </div>
//                 <div style={{ width: "80%" }}>
//                 <span style={{ fontSize: "14px" }}>From&nbsp;&nbsp;</span>
//                   <span>
//                     <input
//                       type="date"
//                       max={maxDate()}
//                       onChange={(e) => onChangeStartDate(e.target.value)}
//                       style={{
//                         border: "1px solid lightgrey",
//                         borderRadius: "4px",
//                         // color: "grey",
//                         fontSize: "14px",
//                         padding: "2px",
//                         fontWeight:'300'
//                       }}
//                     />
//                   </span>
//                   <span style={{ fontSize: "14px" }}>&nbsp;&nbsp;To&nbsp;</span>
//                   <span>
//                     &nbsp;
//                     <input
//                       value={endDate}
//                       min={startDate}
//                       max={maxDate()}
//                       style={{
//                         border: "1px solid lightgrey",
//                         borderRadius: "4px",
//                         // color: "grey",
//                         fontSize: "14px",
//                         padding: "2px",
//                         fontWeight:'300'
//                       }}
//                       type="date"
//                       onChange={(e) => onChangeEndDate(e.target.value)}
//                     />
//                   </span>
//                 </div>
//               </div>
//               <div
//                 style={{
//                   display: "flex",
//                   // color: "grey",
//                   fontSize: "16px",
//                   alignItems: "center",
//                   justifyContent:'center',
//                   marginTop:'10px',
//                   fontWeight:'300'
//                 }}
//               >
//                 <div
//                   style={{ width: "20%", textAlign: "left", fontSize: "15px" }}
//                 >
//                   Domains:
//                 </div>
//                 <div style={{marginTop:'12px', width:'80%'}}>
//                   <span>
//                     <MultiSelectCmTwo
//                       disabled={false}
//                       value={domains}
//                       onChangeFunc={(e) => setDomain(e)}
//                       isMulti={true}
//                       options={filterDomainsForComponent2(userState.cmTopics)}
//                     />
//                   </span>
//                 </div>
//               </div>
//             </div>
//             <div
//               className="searchsuggestionModal"
//               style={{ textAlign: "end" }}
//             >
//               <button
//                 className="shareSubmitButtonAF btn"
//                 style={{ fontSize: "14px" }}
//                 onClick={() => onClickSubmit()}
//               >
//                 Submit
//               </button>
//             </div>
//           </Modal.Body>
//         </Modal>
//       </div>
//     </>
//   );
// }

import React from "react";
// import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import "./AFModalsStyles.css";
import MultiSelectCmTwo from "../../MultiSelectCmTwo/MultiSelectCmTwo";
import { filterDomainsForComponent2 } from "../../../utils";
import { BASE_URL, currentGroup } from "../../../API/url";
import { Modal, ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";
import ReusableMultiSelect from "../../../NewComponent/ReusableMultiSelect";
import styles from './DataExport.module.css'

// import { textAlign } from "html2canvas/dist/types/css/property-descriptors/text-align";


const textStyles = {
  fontSize: "18px",
  color: "#2A364A",
  lineHeight: "24px",
  fontWeight: "500",
  wordBreak: 'break-word', overflowWrap: 'break-word',
};


const textStyles1 = {
  fontSize: "18px",
  color: "#2A364A",
  lineHeight: "24px",
  fontWeight: "500",
  wordBreak: 'break-word', overflowWrap: 'break-word',
  textAlign: "left",




};

const modalTitleStyle = {
  color: "rgb(42, 54, 74)",
  fontSize: "20px",
  fontFamily: "Helvetica",
};
export function DataExportModal() {
  const [domains, setDomain] = React.useState([]);
  const [startDate, setStart] = React.useState("");
  const [endDate, setEnd] = React.useState("");
  const dispatch = useDispatch();
  const { advanceFilterModalToggle } = bindActionCreators(Actions, dispatch);
  const modalState = useSelector((state) => state.domain);
  // const searchState = useSelector((state) => state.search);
  const userState = useSelector((state) => state.user);
  const cmRootState = useSelector((state) => state.cmRoot);


  const maxDate = () => {
    let newDate = new Date();
    return newDate.toISOString().split("T")[0];
  };


  const onChangeStartDate = (date) => {
    let newDate = new Date(date);
    setStart(newDate.toISOString().split("T")[0]);
  };
  const onChangeEndDate = (date) => {
    let newDate = new Date(date);
    setEnd(newDate.toISOString().split("T")[0]);
  };
  const onClickSubmit = () => {
    const mapDomains = domains.map(dom => {
      return dom.indexId;
    });
    let levelId = cmRootState.selecetdRoutingValue;
    let levelValue = levelId === 3 ? "" : cmRootState.selectedGeoLevel["label"];
    let commonUrl = BASE_URL + '/cmuser/group/' + currentGroup + '/dataexport?type=' + 'expertrecords' + '&status=answered&showanswer=true';
    let startTimeParam = startDate != "" ? `&starttime=${startDate}` : "";
    let endTimeParam = endDate != "" ? `&endtime=${endDate} 23:59:59` : "";
    let domainParam = domains != "" ? `&domains=${encodeURIComponent(mapDomains.sort().toString())}` : "";
    let fullLink = `${commonUrl}&levelid=${levelId}&levelvalue=${levelValue}${startTimeParam}${endTimeParam}&timezone=${Intl.DateTimeFormat().resolvedOptions().timeZone}${domainParam}`;
    window.open(fullLink, '_blank');
    advanceFilterModalToggle({ bool: false, value: "" })
  };
  console.log("domains", domains, filterDomainsForComponent2(userState.cmTopics))
  const changeDomain = (selectedValues) => {
    // console.log("Selected values:", selectedValues);


    // Get full objects from value array
    const selectedDomains = filterDomainsForComponent2(userState.cmTopics).filter(item =>
      selectedValues.includes(item.value)
    );


    // console.log("Selected domain objects:", selectedDomains);


    setDomain(selectedDomains);
  };
  return (
    <>
      <div>
        {/* <Modal
         show={modalState.modalState}
       
         style={{marginTop:"5%"}}
         onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
         backdrop="static"
       >
         <Modal.Header
           closeButton
           closeVariant="white"
           className="modalHeaders"
         >
           <Modal.Title style={{ fontSize: "17px" }}>
             <i className="fa fa-files-o"></i> &nbsp;&nbsp;Data Export
           </Modal.Title>
         </Modal.Header>
         <Modal.Body style={{ paddingBottom: "0px" }}>
           <div style={{ marginTop: "5px", width: "90%", margin: "auto", marginInline:'0px' }}>
             <div
               style={{
                 display: "flex",
                 // color: "grey",
                 fontSize: "18px",
                 alignItems: "center",
                 justifyContent:'center',
                 fontWeight:'300'
               }}
             >
               <div
                 style={{ width: "20%", textAlign: "left", fontSize: "15px" }}
               >
                 Date:
               </div>
               <div style={{ width: "80%" }}>
               <span style={{ fontSize: "14px" }}>From&nbsp;&nbsp;</span>
                 <span>
                   <input
                     type="date"
                     max={maxDate()}
                     onChange={(e) => onChangeStartDate(e.target.value)}
                     style={{
                       border: "1px solid lightgrey",
                       borderRadius: "4px",
                       // color: "grey",
                       fontSize: "14px",
                       padding: "2px",
                       fontWeight:'300'
                     }}
                   />
                 </span>
                 <span style={{ fontSize: "14px" }}>&nbsp;&nbsp;To&nbsp;</span>
                 <span>
                   &nbsp;
                   <input
                     value={endDate}
                     min={startDate}
                     max={maxDate()}
                     style={{
                       border: "1px solid lightgrey",
                       borderRadius: "4px",
                       // color: "grey",
                       fontSize: "14px",
                       padding: "2px",
                       fontWeight:'300'
                     }}
                     type="date"
                     onChange={(e) => onChangeEndDate(e.target.value)}
                   />
                 </span>
               </div>
             </div>
             <div
               style={{
                 display: "flex",
                 // color: "grey",
                 fontSize: "18px",
                 alignItems: "center",
                 justifyContent:'center',
                 marginTop:'10px',
                 fontWeight:'300'
               }}
             >
               <div
                 style={{ width: "20%", textAlign: "left", fontSize: "15px" }}
               >
                 Domains:
               </div>
               <div style={{marginTop:'12px', width:'80%'}}>
                 <span>
                   <MultiSelectCmTwo
                     disabled={false}
                     value={domains}
                     onChangeFunc={(e) => setDomain(e)}
                     isMulti={true}
                     options={filterDomainsForComponent2(userState.cmTopics)}
                   />
                 </span>
               </div>
             </div>
           </div>
           <div
             className="searchsuggestionModal"
             style={{ textAlign: "end" }}
           >
             <button
               className="shareSubmitButtonAF btn"
               style={{ fontSize: "14px" }}
               onClick={() => onClickSubmit()}
             >
               Submit
             </button>
           </div>
         </Modal.Body>
       </Modal> */}


        <Modal
          show={modalState.modalState}
          onHide={() => advanceFilterModalToggle({ bool: false, value: "" })}
          centered={true}
          size={"lg"}
        // dialogClassName={styles.modalDialog}
        >
         
          <Modal.Header closeButton>
            <Modal.Title style={modalTitleStyle}>
              <i className="fa fa-files-o"></i>
              &nbsp;&nbsp;Data Exports
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>




            <form className={styles.dataExportForm}>
              <div className={styles.formRow}>
                <label>Date&nbsp;</label>
                <div className={styles.dateRange}>
                <span className={styles.toText}>From&nbsp;</span>
                  <span>
                    <input
                      type="date"
                      max={maxDate()}
                      onChange={(e) => onChangeStartDate(e.target.value)}
                      style={{
                        border: "1px solid lightgrey",
                        borderRadius: "4px",
                        // color: "grey",
                        fontSize: "14px",
                        padding: "2px",
                        fontWeight: '300'
                      }}
                    />
                  </span>
                  <span className={styles.toText}>To&nbsp;</span>
                  <span>
                    &nbsp;
                    <input
                      value={endDate}
                      min={startDate}
                      max={maxDate()}
                      style={{
                        border: "1px solid lightgrey",
                        borderRadius: "4px",
                        // color: "grey",
                        fontSize: "14px",
                        padding: "2px",
                        fontWeight: '300'
                      }}
                      type="date"
                      onChange={(e) => onChangeEndDate(e.target.value)}
                    />
                  </span>
                </div>
              </div>

              <div className={styles.formRow}>
                <label>Domains&nbsp;</label>
                <span style={{width:"200px"}}>

               
                <ReusableMultiSelect
                  value={domains}
                  onChange={(e) => changeDomain(e)}
                  options={filterDomainsForComponent2(userState.cmTopics)}
                  placeholder="Select Domains"
                  maxTagPlaceholder={`${domains?.length || 0} selected`}
                  allowClear={true}
                  disabled={false}
                />
                 </span>
              </div>

              <div className={styles.submitRow}>
                <button
                  style={{
                    padding: '8px 12px 8px 12px',
                    borderRadius: '6px',
                    fontSize: '14px',
                    lineHeight: '24px',
                    fontWeight: 400,
                    boxShadow: '0px 1px 2px 0px #1018280D',
                    color: '#FFFFFF',
                    border: '1px solid  #fff',
                    height: '40px',
                    minWidth: '88px',
                    background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                    marginBottom: '14px',
                    // marginTop: "15px"
                  }}
                  onClick={() => onClickSubmit()}
                >
                  Submit
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </div >
    </>
  );
}

